export default __webpack_public_path__ + "static/media/Favorites.06c9cbe3.jpg";